import React from 'react'

function StoryDefaultAsset(props) {
  const { asset } = props
  return (<div>{ asset.type }</div>)
}

export default StoryDefaultAsset
